import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import { topRatedFundsSeriesPropTypes } from '../common/prop-types';
import useFundsStateStore from '../common/funds-state-hook';
import { Description, Name, Results } from './hero-components/styles';

const Banner = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: start;
  background-repeat: round;
  background-size: cover;
  background-image: url(${props => props.topRatedFundSeriesDesktopBackground});
  padding: 32px 28px;
  width: 100%;
  z-index: 210;

  ${props => dt(props).theme.isXLarge && `
    padding: 32px calc(50% - 476px);
  `};

  ${props => dt(props).theme.isXXLarge && `
    padding: 32px calc(50% - 600px);
  `};

  ${props => dt(props).theme.isMobile && `
    flex-direction: column;
    padding: 36px 20px 40px;
    background-image: url(${props.topRatedFundSeriesMobileBackground});
  `};
`;

const Logo = styled.img`
  max-width: 126px;

  ${props => dt(props).theme.isMobile && `
    margin-left: auto;
    margin-bottom: 28px;
    max-width: 101px;
  `};
`;

const Primary = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 520px;

  ${props => dt(props).theme.isMobileOrTablet && `
    max-width: 372px;
  `};

  ${props => dt(props).theme.isMobile && `
    max-width: 100%;
  `};
`;

const ViewSeriesLink = styled.a`
  border: 1px solid ${props => dt(props).theme.primaryColor};
  border-radius: 4px;
  color: ${props => dt(props).theme.primaryColor};
  font-size: 16px;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  text-transform: uppercase;
  margin-top: 24px;
  width: 165px;
  height: 40px;
  background: transparent;
  text-align: center;
  padding-top: 11px;

  ${props => dt(props).theme.isMobile && `
    width: 100%;
  `};

  &:hover {
    text-decoration: none !important;
    cursor: pointer;
  }
`;

const TOP_RATED_FUNDS_SERIES_URL = 'https://topratedfundsseries.livewiremarkets.com/?utm_campaign=Top+Rated+Fund+Series&utm_medium=livewire+website&utm_source=engagement+campaign&utm_content=listings+page+banner';

export default function TopRatedFundsSeriesHero({
  topRatedFundSeriesDesktopBackground,
  topRatedFundSeriesMobileBackground,
  topRatedFundSeriesLogo,
}) {
  const totalResults = useFundsStateStore(state => state.totalResults);
  const resultsText = totalResults !== null ? `${totalResults} Result${totalResults === 1 ? '' : 's'}` : null;

  return (
    <Banner
      topRatedFundSeriesDesktopBackground={topRatedFundSeriesDesktopBackground}
      topRatedFundSeriesMobileBackground={topRatedFundSeriesMobileBackground}
    >
      <Logo src={topRatedFundSeriesLogo} />
      <Primary>
        {!!resultsText && <Results>{resultsText}</Results>}
        <Name>Australia’s 100 Top-Rated Funds</Name>
        <Description>
          Discover Australia’s top-rated funds in each asset class
          and understand their fee structure, performance and philosophy.
        </Description>
        <ViewSeriesLink href={TOP_RATED_FUNDS_SERIES_URL}>View The Series</ViewSeriesLink>
      </Primary>
    </Banner>
  );
}

TopRatedFundsSeriesHero.propTypes = topRatedFundsSeriesPropTypes;
